import { render, staticRenderFns } from "./model-keywordSearch.vue?vue&type=template&id=24aa1ff7&scoped=true&"
import script from "./model-keywordSearch.vue?vue&type=script&lang=js&"
export * from "./model-keywordSearch.vue?vue&type=script&lang=js&"
import style0 from "./model-keywordSearch.vue?vue&type=style&index=0&id=24aa1ff7&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24aa1ff7",
  null
  
)

export default component.exports